import { USER_ACCOUNT_SETTINGS_API } from 'modules/profile/account-settings/api/account-settings-api'
import { AccountSettingsInterface } from 'modules/profile/account-settings/types/account-settings-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useAccountSettings() {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, AccountSettingsInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: userAccount, mutate } = useSWR(() => {
    if (user) {
      return USER_ACCOUNT_SETTINGS_API
    }
    return null
  }, fetcher)
  return { userAccount, mutate }
}
